import BlainBaseService from "../BlainBaseService";
import { IAutoPartsVehicleCombinedMake, IAutoPartsVehicleEngine, IAutoPartsVehicleModel } from "JS/types/Automotive";
import { objectToQueryString } from "JS/utilities/url";

export interface IVehicleLookupService {
	getTireYears(): Promise<string[]>;
	getTireMakes(year: number | string): Promise<string[]>;
	getTireModels(year: number | string, make: string): Promise<string[]>;
	getTireTrims(year: number | string, make: string, model: string): Promise<string[]>;
	getTireSizes(year: number | string, make: string, model: string, trim: string | false): Promise<string[]>;
	getAutoPartYears(): Promise<number[]>
	getAutoPartMakes(year: number): Promise<IAutoPartsVehicleCombinedMake[]>
	getAutoPartModels(year: number, makeId: number): Promise<IAutoPartsVehicleModel[]>
	getAutoPartEngines(year: number, makeId: number, modelId: number): Promise<IAutoPartsVehicleEngine[]>
}

export class VehicleLookupService extends BlainBaseService implements IVehicleLookupService {

	/* Tires
	============================================*/

	getTireYears(): Promise<string[]> {
		return this._httpSvc.get<string[]>('/vehicle-lookup/tires/years/');
	}

	getTireMakes(year: number | string): Promise<string[]> {
		const url = `/vehicle-lookup/tires/makes/?year=${year}`;
		return this._httpSvc.get<string[]>(url);
	}

	getTireModels(year: number | string, make: string): Promise<string[]> {
		const url = `/vehicle-lookup/tires/models/?${objectToQueryString({ year, make })}`;
		return this._httpSvc.get<string[]>(url);
	}

	getTireTrims(year: number | string, make: string, model: string): Promise<string[]> {
		const url = `/vehicle-lookup/tires/trims/?${objectToQueryString({ year, make, model })}`;
		return this._httpSvc.get<string[]>(url);
	}

	getTireSizes(year: number | string, make: string, model: string, trim: string | false): Promise<string[]> {
		const query: Record<string, string | number> = { year, make, model };

		if (typeof trim === 'string') {
			query.trim = trim;
		}

		const url = `/vehicle-lookup/tires/sizes/?${objectToQueryString(query)}`;
		return this._httpSvc.get<string[]>(url);
	}

	/* Auto Parts
	============================================*/

	async getAutoPartYears(): Promise<number[]> {
		return this._httpSvc.get<number[]>('/vehicle-lookup/parts/years/');
	}

	async getAutoPartMakes(year: number): Promise<IAutoPartsVehicleCombinedMake[]> {
		const url = `/vehicle-lookup/parts/makes/?year=${year}`;
		return this._httpSvc.get<IAutoPartsVehicleCombinedMake[]>(url);
	}

	async getAutoPartModels(year: number, makeId?: number, truckMakeId?: number): Promise<IAutoPartsVehicleModel[]> {
		const url = `/vehicle-lookup/parts/models/?year=${year}&makeId=${makeId}&truckMakeId=${truckMakeId}`;
		return this._httpSvc.get<IAutoPartsVehicleModel[]>(url);
	}

	async getAutoPartEngines(year: number, makeId: number, modelId: number): Promise<IAutoPartsVehicleEngine[]> {
		const url = `/vehicle-lookup/parts/engines/?year=${year}&makeId=${makeId}&modelId=${modelId}`;
		return this._httpSvc.get<IAutoPartsVehicleEngine[]>(url);
	}

}